export const MIN_VERSION_CHECK_TIME = 2 * 60 * 1000; // 2 min
export const MAX_VERSION_CHECK_TIME = 10 * 60 * 1000; // 10 min
export const VERSION_REQUEST_TIMEOUT = 3 * 1000; // 3 sec
export const VERSION_REQUEST_RETRY_DELAY = 1 * 1000; // 1 sec
export const VERSION_REQUEST_RETRIES = 3;
